import SearchField from './SearchField';
import { peopleListSurfaceClass } from '../../config/glassSurfaces';

/** Sticky search strip — matches Followers/Following modal in People.js */
export function ModalSearchBar({ children }) {
  return <div className="shrink-0 border-b border-white/10 px-6 pb-3 pt-1">{children}</div>;
}

export function ModalSearchInput({ value, onChange, placeholder, autoFocus = false, inputRef }) {
  return (
    <SearchField
      ref={inputRef}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      autoFocus={autoFocus}
    />
  );
}

export const modalSearchScrollClassName =
  'flex-1 min-h-0 overflow-y-auto px-6 py-4 [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-track]:bg-gray-100 [&::-webkit-scrollbar-track]:dark:bg-dark-bg [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-gray-300 [&::-webkit-scrollbar-thumb]:dark:bg-dark-border';

export function ModalSearchListSkeleton({ count = 8, showAvatar = true }) {
  return (
    <ul className={peopleListSurfaceClass()} aria-hidden>
      {Array.from({ length: count }).map((_, i) => (
        <li key={i} className="flex min-h-[72px] items-center gap-3 px-4 py-3.5 animate-pulse">
          {showAvatar ? (
            <div className="h-10 w-10 flex-shrink-0 rounded-full skeleton-shimmer" />
          ) : null}
          <div className="min-w-0 flex-1 space-y-2">
            <div className="h-3.5 w-2/5 rounded skeleton-shimmer" />
            <div className="h-3 w-24 rounded skeleton-shimmer" />
          </div>
          {!showAvatar ? <div className="h-8 w-20 shrink-0 rounded skeleton-shimmer" /> : null}
        </li>
      ))}
    </ul>
  );
}

export function ModalSearchEmptyState({ children }) {
  return <div className="py-12 text-center text-gray-500 dark:text-dark-muted">{children}</div>;
}

/** Result row spacing — sits inside {@link peopleListSurfaceClass} list shell */
export function ModalSearchResultRow({ children, className = '' }) {
  return (
    <div
      className={`flex min-h-[52px] items-center justify-between gap-3 rounded-lg px-2 py-2.5 ${className}`}
    >
      {children}
    </div>
  );
}
